import { render, staticRenderFns } from "./detailsubscribe.vue?vue&type=template&id=22529147"
import script from "./detailsubscribe.vue?vue&type=script&lang=js"
export * from "./detailsubscribe.vue?vue&type=script&lang=js"
import style0 from "./detailsubscribe.vue?vue&type=style&index=0&id=22529147&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports